export const AGENT_RUN_UPDATED_SUBJECT = "agent-run.updated";

// An invalidation, not a payload: the receiver refetches the list through the
// authorized GET, so nothing a user may not see travels over the workspace
// subject.
export interface AgentRunUpdatedEvent {
    runId: string;
    workspaceId: string;
    /** Set when a user started, paused, resumed or stopped the run; null for worker writes */
    updatedByUserId: number | null;
}
